// extracted by mini-css-extract-plugin
export default {"link":"XM-z","disabled":"YM-z"};